'use client';

import { buildVideoStreamUrl } from '@repo/sdk';
import { Button } from '@repo/ui';
import { X } from 'lucide-react';
import { type JSX, type MouseEvent, useEffect } from 'react';

interface ICropVideoPreviewProps {
  localPath: string;
  onClose: () => void;
}

export function CropVideoPreview({ localPath, onClose }: ICropVideoPreviewProps): JSX.Element {
  const videoUrl = buildVideoStreamUrl(localPath);

  useEffect(() => {
    const handler = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onClose]);

  return (
    // biome-ignore lint/a11y/noStaticElementInteractions: backdrop div handles click-to-close
    // biome-ignore lint/a11y/useKeyWithClickEvents: keyboard close handled via useEffect above
    <div
      className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center"
      onClick={onClose}
    >
      {/* biome-ignore lint/a11y/noStaticElementInteractions: inner div stops propagation */}
      {/* biome-ignore lint/a11y/useKeyWithClickEvents: keyboard close handled via useEffect above */}
      <div
        className="relative w-full max-w-3xl mx-4"
        onClick={(e: MouseEvent) => e.stopPropagation()}
      >
        <Button
          variant="ghost"
          size="sm"
          onClick={onClose}
          className="absolute -top-10 right-0 text-white hover:text-white/80"
        >
          <X className="h-5 w-5" />
        </Button>
        <video controls autoPlay className="w-full rounded-lg" src={videoUrl}>
          <track kind="captions" />
        </video>
      </div>
    </div>
  );
}
